import React from 'react';
import { Text, TextProps } from 'react-native';
import { useStyles } from 'react-native-unistyles';

export default function MyAppText(props: TextProps) {
    const { theme } = useStyles();

    return <Text {...props} style={[{
        fontFamily: 'Open Sans',
        color: theme.colors.textColor
    }, props.style]}>{props.children}</Text>;
}
